<template>
    <vx-card id="loader">
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row mb-4">
                    <h4 class="float-left">Сопоставление аккаунтов</h4>
                    <feather-icon
                        @click="showPopup()"
                        icon="HelpCircleIcon"
                        class="text-info vopros cursor-pointer page-description"
                        svgClasses="w-5 h-5"
                    />
                </div>
                <vs-popup title="Подробнее" v-if="popupContent" :active.sync="popupIsVisible"><span v-html="popupContent"></span></vs-popup>
            </vs-col>
        </vs-row>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <label class="vs-input--label"> Пользователи </label>
                <v-select
                    multiple
                    :options="dicts.users"
                    label="email"
                    placeholder="Выберите пользователей"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.users }"
                    v-model="form.users"
                >
                </v-select>
            </div>
            <div class="vx-col w-1/6">
                <label class="vs-input--label"> Бренд (DSP) </label>
                <v-select
                    disabled
                    multiple
                    clearable
                    :options="dicts.brandTypes"
                    placeholder="Выберите бренд"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.brandTypes }"
                    v-model="form.brandTypes"
                >
                </v-select>
            </div>
            <div class="vx-col w-1/5">
                <label class="vs-input--label"> Роль </label>
                <v-select
                    disabled
                    clearable
                    :options="dicts.roles"
                    placeholder="Выберите роль"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.role }"
                    v-model="form.role"
                >
                </v-select>
            </div>
            <div class="vx-col">
                <label class="vs-input--label"> На странице </label>
                <v-select
                    :options="dicts.pageSizes"
                    label="name"
                    placeholder="На странице..."
                    class="w-full"
                    v-model="pageSize"
                    :clearable="false"
                    @input="loadAccountMatching()"
                >
                </v-select>
            </div>
        </div>
        <div class="vx-row mt-1">
            <div class="vx-col w-5/6 mb-1">
                <div class="mt-1">
                    <vs-button class="mt-2" color="success" @click="loadAccountMatching()" type="filled"> Применить </vs-button>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-table :data="items" max-items="10">
                    <template slot="thead">
                        <vs-th> Id</vs-th>
                        <vs-th> e-mail</vs-th>
                        <vs-th> Id из трекера </vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{ data }">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>{{ tr.userId }}</vs-td>
                            <vs-td>{{ tr.email }}</vs-td>
                            <vs-td>
                                <vs-input placeholder="id трекера через запятую" autocomplete="off" v-model="tr.trackerAccountIds" class="mt-1 w-full"
                            /></vs-td>
                            <vs-td>
                                <div v-if="!tr.deletedAt" class="inline-block cursor-pointer">
                                    <vx-tooltip text="Сохранить" position="top" delay=".3s">
                                        <feather-icon
                                            @click="saveAccountMatching(tr)"
                                            icon="SaveIcon"
                                            class="inline-block mr-2 text-success"
                                            svgClasses="w-7 h-7"
                                        />
                                    </vx-tooltip>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

export default {
    data() {
        return {
            popupIsVisible: false,
            popupContent: '',

            page: 1,
            pageSize: 100,
            pagesTotal: 1,

            items: [],
            form: {
                users: [],
                role: { label: 'Partners Network', id: '9' },
                brandTypes: [{ label: 'AdProfex', id: '3' }]
            },
            dicts: {
                users: [],
                roles: [],
                brandTypes: [],
                pageSizes: [25, 50, 100, 500]
            },
            errors: {
                users: '',
                brandTypes: '',
                role: ''
            }
        };
    },
    mounted() {
        this.loadDicts();
        this.loadAccountMatching();
    },
    methods: {
        loadDicts() {
            this.axios.get('partners-network/AccountMatching/dicts').then((dicts) => {
                this.dicts.users = dicts.data.users;
            });
        },
        loadAccountMatching() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                userIds: this.form.users ? this.form.users.map((user) => user.id) : undefined,
                brandTypeIds: this.form.brandTypes ? this.form.brandTypes.map((brandType) => brandType.id) : undefined,
                roleId: this.form.role.id,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('partners-network/AccountMatching', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    }),
                    this.axios.get('partners-network/AccountMatching/count', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    })
                ])
                .then(
                    axios.spread((items, count) => {
                        items.data.forEach(element => {
                            element.trackerAccountIds = element.trackerAccountIds ? element.trackerAccountIds.toString() : null;
                        });
                        this.items = items.data;
                        this.pagesTotal = Math.ceil(count.data / this.pageSize);
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        saveAccountMatching(tr) {            
            let trackerAccountIdsForUpdate = [];
            // распарсим input
            let strValues = tr.trackerAccountIds.split(',').map((item) => item.trim());            
            for (var key in strValues) {
                let parsedValue = parseInt(strValues[key]);
                if(isNaN(parsedValue) || parsedValue < 1)
                {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Указано некорректное значение.',
                        color: 'danger'
                    });
                    return;
                }
                trackerAccountIdsForUpdate.push(parseInt(strValues[key]));
            }

            var params = {
                userId: tr.userId,
                trackerAccountIds: trackerAccountIdsForUpdate
            };

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'POST',
                url: 'partners-network/AccountMatching',
                params: params,
                paramsSerializer: (params) => {
                    return qs.stringify(params);
                },
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Успешно обновлено',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сохранении!',
                        color: 'danger'
                    });
                }
            });
        },
        showPopup() {
            this.popupContent = 'Механизм сопоставления  ID нашего аккаунта с ID аккаунта из трекера';
            this.popupIsVisible = true;
        }
    },
    components: {
        'v-select': vSelect,
        SweetModal,
        SweetModalTab
    }
};
</script>
<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

.header-title {
    flex-direction: column;
}

.vs-con-table .vs-con-tbody,
.vs-table--content {
    overflow: initial;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    -webkit-transform: none;
}
</style>